// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__BpzJM","content":"Tooltip_content__hKN5w"};